<div data-testid="order-source-page" class="p-4 flex-table-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "order.source.title" | translate }}
  </h2>
  <!-- Search Form -->
  <app-search-form
    data-testid="order-source-search-form"
    [orderSources]="channels"
    [salesChannels]="stores"
    [buyerNotesOptions]="sourceStatuses"
    [giftOptions]="[]"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton"
        [secondaryButton]="secondaryButton"
        (primaryButtonClick)="reSource()"
        (secondaryButtonClick)="specifyShipment()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Status Filter with Action Buttons -->
  <div class="mb-2 flex-table-header">
    <app-status-filter
      [statusOptions]="statusOptions"
      (statusChange)="onStatusChange($event)"
    ></app-status-filter>
  </div>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      data-testid="order-source-table"
      [dataSource]="orders"
      [columns]="columns"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [loading]="loading"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    </app-data-table>
  </div>
</div>
